import { render, staticRenderFns } from "./CarView.vue?vue&type=template&id=f7d20954"
import script from "./CarView.vue?vue&type=script&lang=js"
export * from "./CarView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports